import { Machine, assign } from "xstate";

const context = {
  // FIXME: This is a bit of a duplication of state, in future this machine should be in charge of updating the element too
  selectedElement: null,
};

export default Machine(
  {
    id: "element",

    context,

    initial: "setup",

    states: {
      setup: {
        on: {
          "": [
            {
              target: "selected", // Only transition if the guard (cond) evaluates to true...
              cond: "selectedElementExists",
            },
            { target: "unselected" },
          ],
        },
      },
      unselected: {
        on: {
          SELECT: "selecting",
        },
      },
      selected: {
        on: {
          SELECT: "selecting",
          REMOVE: {
            target: "unselected",
            actions: "updateSelectedElement",
          },
        },
      },
      selecting: {
        id: "selecting",
        on: {
          SELECTED: {
            target: ".",
            actions: "updateSelectedElement",
          },
          CLOSE: [
            {
              target: "selected", // Only transition if the guard (cond) evaluates to true...
              cond: "selectedElementExists",
            },
            { target: "unselected" },
          ],
        },
      },
    },
  },
  {
    actions: {
      updateSelectedElement: assign({
        selectedElement: (context, event) =>
          event?.data?.selectedElement ?? null,
      }),
    },
    guards: {
      selectedElementExists: (ctx) => {
        return ctx?.selectedElement?.elementId;
      },
    },
  }
);
